import { render, staticRenderFns } from "./UsersNotifications.vue?vue&type=template&id=7e790a7a&scoped=true"
import script from "./UsersNotifications.vue?vue&type=script&lang=js"
export * from "./UsersNotifications.vue?vue&type=script&lang=js"
import style0 from "./UsersNotifications.vue?vue&type=style&index=0&id=7e790a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e790a7a",
  null
  
)

export default component.exports